import { geoTransverseMercator, geoPath } from 'd3-geo'
import PropTypes from 'prop-types'
import React, { Component } from 'react'


const getWardFill = (member, highlight) => {
  if (!member) {
    return 'rgba(255, 255, 255, 0)'
  }

  // TODO: Better colors

  if (highlight) {
    return '#2F4F4F'
  }

  return '#ccc'
}

/**
 * Render an SVG map of Chicago wards.
 *
 * https://medium.com/@zimrick/how-to-create-pure-react-svg-maps-with-topojson-and-d3-geo-e4a6b6848a98
 * was massively helpful in figuring out how to do this.
 */
class CommitteeWardMap extends Component {
  handleClickWard(ward) {
    this.props.onClickWard(ward)
  }

  render() {
    if (!this.props.wards || !this.props.members) {
      return false
    }

    const width = this.props.width
    // Calculate height based on width. I got this aspect ratio by using the
    // Firefox inspector on a roughly rendered version of the map.
    const height = 1.21 * width

    // NAD83 / Illinois West (EPSG:26972)
    // via https://github.com/veltman/d3-stateplane
    const proj = geoTransverseMercator()
      .rotate([88 + 20 / 60, -36 - 40 / 60])
      .fitSize([width, height], this.props.wards)


    // TODO: Pass in the member by ward lookup because I think we now
    // build it upstream and it's slow to do it again for each map.
    const memberLookup = {}

    this.props.members.forEach(member => {
      memberLookup[member.ward] = member
    })

    return (
      <svg className="CommitteeWardMap" width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
        <g className="wards">
        {
          this.props.wards.features.map((d,i) => (
            <path
              key={`path-${i}`}
              d={geoPath().projection(proj)(d)}
              className="ward"
              fill={
                getWardFill(
                  memberLookup[d.properties.ward],
                  parseInt(d.properties.ward, 10) === this.props.highlightWard
                )
              }
              stroke="#000"
              strokeWidth="0.5"
              onClick={() => this.handleClickWard(memberLookup[d.properties.ward])} />
          ))
        }
        </g>
      </svg>
    )
  }
}

CommitteeWardMap.propTypes = {
  wards: PropTypes.object,
  members: PropTypes.array,
  highlightWard: PropTypes.number,
  onClickWard: PropTypes.func
}

export default CommitteeWardMap



// WEBPACK FOOTER //
// ./src/CommitteeWardMap.js